import App from "./App.svelte";
const load = () => {
    // Short-circuit if there are any existing embeds rendered already
    if (document.querySelector("[data-apply-now-app]")) {
        console.warn("An Apply Now button was already rendered on the page; skipping.");
        return;
    }
    const container = document.createElement("div");
    container.dataset.applyNowApp = "true";
    document.body.appendChild(container);
    new App({
        target: container,
    });
};
if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
        load();
    });
}
else {
    load();
}
